<template>
  <div>
    <el-table :data="subdata" style="width:100%;margin-bottom:10px;" border>
      <el-table-column prop="frequency" label="频率" :width="75" sortable class-name="custom-column">
      </el-table-column>
      <el-table-column prop="name" label="名称" sortable class-name="custom-column">
      </el-table-column>
      <el-table-column prop="area" label="地区" :width="80" align="center" class-name="custom-column">
      </el-table-column>
      <el-table-column label="录音" :width="50" align="center" class-name="custom-column">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_recording" :active-value="1" :inactive-value="0" :width="35" :ref="scope.row.id"
            disabled>
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <Pagination ref="pagination" :totalCountOrURL="data.length" :params="{}" @change="handlePageChange"></Pagination>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination"
  export default {
    props: ["whiteListIds"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      // 组件参数变化时，刷新数据
      whiteListIds() {
        this.getData();
      }
    },
    data() {
      return {
        data: [],
        subdata: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.subdata = this.data.slice(this.size * (this.page - 1), this.size * this.page);
      },
      getData() {
        if (this.whiteListIds) {
          let ids = [];
          for (let key in this.whiteListIds) {
            ids.push(key);
          }
          this.$getJSON("/task/s_allWhitelst", {
            options: [{
              type: "6",
              name: "id",
              value: ids
            }]
          }).then(res => {
            let data = res.data;
            for (let i = 0; i < data.length; i++) {
              data[i].is_recording = this.whiteListIds[data[i].id];
            }
            this.data = data;
            this.subdata = this.data.slice(this.size * (this.page - 1), this.size * this.page);
          });
        } else {
          this.data = [];
          this.subdata = [];
        }
      }
    }
  };

</script>

<style scoped>
  .custom-column {
    padding: 2px 0 !important;
    color: #aaaaaa;
  }

</style>



// WEBPACK FOOTER //
// src/components/Tables/WhiteListOfTask.vue